(() => {
  const styleId = 'bontas-whatsapp-sizing';
  let pending = false;
  const apply = () => {
    pending = false;
    document.querySelectorAll('gty-whatsapp-chat-button').forEach((host) => {
      const root = host.shadowRoot;
      if (!root || root.getElementById(styleId)) return;
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = '.gty-wacb-button-container{width:42px!important;height:42px!important;scale:none!important}.gty-wacb-button{width:42px!important;height:42px!important;min-width:42px!important;min-height:42px!important;padding:0!important}.gty-wacb-button svg{width:23px!important;height:23px!important}.gty-wacb-notification-badge{transform:scale(.75);transform-origin:top right}';
      root.appendChild(style);
    });
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(apply); } };
  customElements.whenDefined('gty-whatsapp-chat-button').then(schedule);
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  apply();
})();